module.exports = __webpack_public_path__ + "static/media/shield.06135e7e.svg";